import React from 'react'
import { cn } from 'lib/utils'

export default function RadioGroup({ name, label, value, onChange, items, className }) {
	return (
		<fieldset className={cn('tw-form-control', className)}>
			{label && <legend className="text-sm font-medium mb-1.5">{label}</legend>}
			<div className="flex items-center gap-4">
				{items.map(item => (
					<label key={item.id} className="flex items-center gap-1.5 cursor-pointer text-sm">
						<input
							type="radio"
							name={name}
							value={item.id}
							checked={value === item.id}
							onChange={onChange}
							className="h-4 w-4 accent-primary"
						/>
						{item.title}
					</label>
				))}
			</div>
		</fieldset>
	)
}
